export default "<button title=\"{{'BUTTONS.DISABLE' | translate}}\" class=\"btn btn-danger\" (click)=\"disable()\">{{'BUTTONS.DISABLE' | translate}}</button>";